<template>
    <div class="product-box drop-shadow" @click="openSingle()">
        <div class="badge" :class=" ( product.attributes._sale_price ? 'on-sale' : ( product.new ? 'new' : '' ) ) ">
            <span v-if="product.attributes._sale_price">
                <!--off<br>{{ Math.round( 100 - ( ( product.attributes._price / product.attributes._regular_price ) * 100 ) ) }}%-->
                sale
            </span>
            <span v-else-if="product.new">NEW</span>
        </div>
        <div class="thumb" :style="'background-image: url('+product.attributes._thumbnail_id+')'"></div>
        <small> {{ product.attributes.grape ? product.attributes.grape[0] : '' }} {{ product.attributes.country ? '- origin '+product.attributes.country[0] : '' }}</small>
        <h4 class="eagle font-18 mb-3">{{ product.title }}</h4>
        <span class="price mb-4 font-24 eagle">{{ this.displayPrice(product.attributes._price, this.$root.currency) }}</span>
        <footer>
            <b-row align-v="center">
                <b-col cols="12" md="6">
                    <span class="rating font-12">
                        <!--<i class="fas fa-star"></i>{{ product.rating }} ({{ product.reviews }})-->
                    </span>
                </b-col>
                <b-col cols="12" md="6">
                    <a
                            href=""
                            class="add-to-cart single_add_to_cart_button"
                            :class="( addedToCart ? 'added-to-cart' : ( addToCartError ? 'add-to-cart-error' : '' ) )"
                            @click.stop.prevent="addToCart(product.id, product.attributes._sku)"
                            v-if="!product.voucher"
                    >
                        <span></span>
                        <span class="checkmark">
                            <div class="checkmark_stem"></div>
                            <div class="checkmark_kick"></div>
                        </span>
                    </a>
                </b-col>
            </b-row>
        </footer>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        name: "ProductBox",
        props: {
            product: Object
        },
        data() {
          return {
              addedToCart: false,
              addToCartError: false
          }
        },
        methods: {
            displayPrice(price, currency) {
                if('undefined' == price || !price) return '';
                if(typeof price == 'object')
                    return currency + this.parsePrice(price[0]) +' - '+ currency + this.parsePrice(price[price.length - 1])
                else
                    return currency + this.parsePrice(price)
            },
            parsePrice(price) {
                return parseFloat(price).toFixed(2)
                // let e = price.split('.');
                // let t = parseFloat(price)
                // if(e.length > 1)
                //     return t.toFixed(2)
                // return t
            },
            addToCart(product_id, product_sku) {
                let data = {
                    quantity: 1,
                    product_id: product_id,
                    product_sku: product_sku,
                    action: 'woocommerce_ajax_add_to_cart'
                };

                this.$axios.post(wc_add_to_cart_params.ajax_url, qs.stringify(data))
                    .then(response => {

                        if(!response.error) {
                            this.addedToCart = true
                            this.addToCartError = false
                            this.$root.$emit('updateCartCount', 1)
                        } else {
                            this.addedToCart = false
                            this.addToCartError = true
                        }

                        // Redirect to cart option handler
                        if(wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                            window.location = wc_add_to_cart_params.cart_url;
                            return;
                        }

                        // Dispatch event so themes can update states etc.
                        document.body.dispatchEvent(new Event( 'added_to_cart', [ response.fragments, response.cart_hash, document.createElement('a') ]));
                    })
                    .catch(error => {
                        console.log({error: error})
                    });
            },
            openSingle: function () {
                window.location.href = this.product.url;
            }
        }
    }
</script>